export const formatAccountOption = (account) => ({
  ...account,
  label: account.code ? `${account.code} - ${account.label}` : account.label,
});

export const formatAccountOptions = (accounts) => accounts.map(formatAccountOption);

export const mergeSavedIntoOptions = (syncedItems, mappings, fields, formatFn) => {
  const options = [...syncedItems];
  const seen = new Set(options.map((o) => o.id));

  fields.forEach(({ key, xero_code: xeroCode }) => {
    const saved = mappings[key];
    if (saved?.id && !seen.has(saved.id)) {
      const account =
        !saved.code && xeroCode ? { ...saved, code: xeroCode } : saved;
      options.push(formatFn(account));
      seen.add(saved.id);
    }
  });

  return options;
};

export const withXeroCodeFallback = (account, xeroCode) => {
  if (!account?.id || account.code || !xeroCode) {
    return account;
  }
  return formatAccountOption({ ...account, code: xeroCode });
};

export const displayLabel = (label) => {
  const idx = label.lastIndexOf(' (');
  return idx > 0 ? label.slice(0, idx) : label;
};

export const sortByXeroCode = (fields) =>
  [...fields].sort((a, b) =>
    (a.xero_code || '').localeCompare(b.xero_code || '', undefined, {
      numeric: true,
      sensitivity: 'base',
    })
  );

export const formatMappedAccountLabel = (account, xeroCode) => {
  if (!account?.id) {
    return null;
  }
  const formatted = withXeroCodeFallback(account, xeroCode);
  return formatted?.label || account.label || null;
};

export const diffAccountMappings = (original, draft, fieldKeys) => {
  const changed = {};

  fieldKeys.forEach((key) => {
    const prevId = original[key]?.id ?? null;
    const nextId = draft[key]?.id ?? null;
    if (prevId !== nextId) {
      changed[key] = draft[key] ?? null;
    }
  });

  return changed;
};

export const hasMappingChanges = (changed) => Object.keys(changed).length > 0;
